export type ReferralStatus = {
  active: boolean;
  displayName?: string;
};

/**
 * Validates a `?ref=<employeeId>` referral against the public
 * referral-status endpoint. Returns `{ active: false }` for any
 * failure mode (network error, unknown id, soft-deleted employee)
 * so callers can treat "unverifiable" identically to "inactive" and
 * fall through to the normal unassigned-queue flow.
 */
export async function getReferralStatus(employeeId: string): Promise<ReferralStatus> {
  const apiBase = process.env.NEXT_PUBLIC_LOAN_APP_API?.replace(/\/$/, '');
  if (!apiBase) return { active: false };

  try {
    const response = await fetch(`${apiBase}/api/v1/employees/${employeeId}/referral-status`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return { active: false };
    const body = (await response.json()) as ReferralStatus;
    return body.active ? { active: true, displayName: body.displayName } : { active: false };
  } catch {
    return { active: false };
  }
}
